<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard" [dragula]='"widget-bag"'>
  <swb-password></swb-password>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard" [dragula]='"widget-bag"'>
  <swb-profile></swb-profile>
</div>